import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';
import { VALIDAR_STOCK } from '../../../common/types/parametroType'
import auth from '../../../common/utility/auth';

export default function ResultList(props) {
    const validarStock = auth.user().parametros.filter(m => m.abreviatura === VALIDAR_STOCK)[0].valor === "1" ? true : false;
    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title={"Editar"}>
                                <Button
                                    disabled={!row.flag}
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onEdit(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title={"Conversion Medida"}>
                                <Button
                                    disabled={!row.flag}
                                    type={"primary"}
                                    icon={"sync"}
                                    size={"small"}
                                    onClick={() => props.handleConversion(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title={row.flag ? "Deshabilitar" : "Habilitar"}>
                                <Button
                                    type={row.flag ? "danger" : "success"}
                                    icon={row.flag ? "close" : "check"}
                                    size={"small"}
                                    onClick={() => props.onInactiveActive(row)}
                                />
                            </Tooltip>
                       
                            <Tooltip placement="top" title={"Codigo de Barra"}>
                                <Button
                                    disabled={!row.flag}
                                    type="primary"
                                    icon="barcode"
                                    size={"small"}
                                    onClick={() => props.handleBarcode(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title={"Eliminar"}>
                                <Button
                                    type={"primary"}
                                    icon={"delete"}
                                    size={"small"}
                                    onClick={() => props.onEliminar(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Nombre',
                    dataIndex: 'nombre',
                    key: 'nombre',
                    sorter: true
                },
                {
                    title: 'Código Referencia',
                    dataIndex: 'codigoReferencia',
                    key: 'codigoReferencia',
                    sorter: true
                },
                {
                    title: 'Código Barras',
                    dataIndex: 'codigoBarra',
                    key: 'codigoBarra',
                    sorter: true
                },
                {
                    title: 'Marca',
                    dataIndex: 'marca',
                    key: 'marca',
                    sorter: true
                },
                {
                    title: 'Modelo',
                    dataIndex: 'modelo',
                    key: 'modelo',
                    sorter: true
                },

                {
                    title: 'Segmento',
                    dataIndex: 'segmentoCategoria',
                    key: 'segmentoCategoria',
                    sorter: true
                },
                {
                    title: 'Familia ',
                    dataIndex: 'familiaCategoria',
                    key: 'familiaCategoria',
                    sorter: true
                },
                {
                    title: 'Clase',
                    dataIndex: 'claseCategoria',
                    key: 'claseCategoria',
                    sorter: true
                },
                {
                    title: 'Producto',
                    dataIndex: 'productoCategoria',
                    key: 'productoCategoria',
                    sorter: true
                },

                {
                    title: 'Peso',
                    dataIndex: 'peso',
                    key: 'peso',
                    align: 'right',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(5)}</span>
                    )
                }
                ,
                {
                    title: 'Impuesto',
                    dataIndex: 'impuesto',
                    key: 'impuesto',
                    sorter: true
                },
                {
                    title: 'Unidad de Medida',
                    dataIndex: 'nombreUnidadMedida',
                    key: 'nombreUnidadMedida',
                    sorter: true
                },
                {
                    title: 'Estado',
                    dataIndex: 'flag',
                    key: 'flag',
                    align: 'center',
                    width: "90px",
                    render: (value) => {
                        return (<div className="custom-options" >
                            <Tag color={value ? "green" : "red"}>{value ? "Activo" : "Inactivo"}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );
}